var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"menu",staticClass:"context-menu",style:(_vm.contextMenuStyle)},[_vm._t("default",function(){return [_vm._v("No Content!")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }